import React, { useEffect } from 'react';
import fourruresImage from '../../images/IMG_20250301_154746.png';
import SEO from '../SEO';
import { CATEGORIES_SEO } from '../../seo/pagesSeo';

function FourruresPage() {
    const seo = CATEGORIES_SEO.fourrures;
    useEffect(() => {
        const root = document.documentElement;
        root.classList.remove('preload');
    }, []);

    const details = [
        'Manteaux de vison',
        'Étoles et capes',
        'Vestes et boléros',
        'Accessoires en fourrure',
        'Cols et manchons',
        'Fourrures d\'astrakan',
        'Renard, chinchilla, et hermine',
        'Pièces vintage et contemporaines',
        'Créations de maisons de prestige',
    ];

    const description = `
En tant qu'antiquaire, je me consacre à l'acquisition de fourrures anciennes, même en état imparfait, tout en garantissant une évaluation raffinée et professionnelle.

L'histoire et l'émotion qui se cachent derrière chaque objet. Chaque pièce est unique et mérite d'être reconnue à sa juste valeur. Que vous souhaitiez vendre un manteau de vison, une étole vintage, col de fourrure, mon expertise me permet d'évaluer vos fourrures anciennes avec soin.

Types de fourrures anciennes : Manteaux, Étoles, Capes, Vestes, Cols, Manchons, Accessoires, Fourrures d'astrakan, Renard, Chinchilla, Hermine, Vison, Créations de prestige, Pièces vintage, Fourrures contemporaines.
    `;

    return (
        <div className="category-page">
            <SEO
                title={seo.title}
                description={seo.description}
                path={seo.path}
            />
            <header className="category-header fade-in" style={{ backgroundImage: `url(${fourruresImage})` }}>
                <div className="overlay"></div>
                <div className="hero-content">
                    <h1>Fourrures</h1>
                </div>
            </header>
            <main className="category-content">
                <section className="category-description">
                    <div className="description-card fade-in">
                        <p>{description}</p>
                    </div>
                </section>
                <section className="category-details">
                    <h2 className="fade-in">Détails</h2>
                    <div className="details-grid">
                        {details.map((detail, index) => (
                            <div key={index} className="detail-card fade-in">
                                <span>{detail}</span>
                            </div>
                        ))}
                    </div>
                </section>
            </main>
            <footer className="category-footer fade-in">
                <a href="/contact" className="cta-button">Contactez-nous</a>
            </footer>

            <style jsx>{`
                .category-page {
                    background: #f2f5f7;
                    min-height: 100vh;
                }

                .category-header {
                    width: 100%;
                    height: 70vh;
                    background-size: contain;
                    background-position: center;
                    background-repeat: no-repeat;
                    background-attachment: fixed;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: relative;
                    color: #fff;
                    background-color: #1f2b2a;
                }

                .overlay {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background-color: rgba(0, 0, 0, 0.3);
                    z-index: 1;
                }

                .hero-content {
                    position: relative;
                    z-index: 2;
                    text-align: center;
                    padding: 20px;
                }

                .category-header h1 {
                    font-size: 3.5rem;
                    font-weight: bold;
                    color: #fff;
                    margin: 0;
                    text-shadow: 0 4px 12px rgba(0, 0, 0, 0.8);
                    letter-spacing: -0.02em;
                }

                .category-content {
                    max-width: 1100px;
                    margin: 0 auto;
                    padding: 48px 24px 80px;
                }

                .description-card {
                    background: #fff;
                    border-radius: 18px;
                    padding: 32px;
                    margin-bottom: 48px;
                    box-shadow: 0 8px 24px rgba(0,0,0,0.12);
                    transition: transform 0.18s ease, box-shadow 0.18s ease;
                }

                .description-card:hover {
                    transform: translateY(-4px);
                    box-shadow: 0 12px 32px rgba(0,0,0,0.16);
                }

                .description-card p {
                    font-size: 1.25rem;
                    line-height: 1.75;
                    color: #44504f;
                    margin: 0;
                    text-align: center;
                }

                .category-details h2 {
                    font-size: 2.6rem;
                    line-height: 1.1;
                    margin: 0 0 32px;
                    color: #1f2b2a;
                    letter-spacing: -0.02em;
                    text-align: center;
                }

                .details-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
                    gap: 20px;
                    margin-bottom: 48px;
                }

                .detail-card {
                    background: #fff;
                    border-radius: 12px;
                    padding: 24px;
                    box-shadow: 0 4px 16px rgba(0,0,0,0.08);
                    transition: transform 0.18s ease, box-shadow 0.18s ease;
                    border-left: 4px solid #C0A26B;
                }

                .detail-card:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 8px 24px rgba(0,0,0,0.12);
                }

                .detail-card span {
                    font-size: 1.05rem;
                    line-height: 1.6;
                    color: #44504f;
                    display: block;
                }

                .category-footer {
                    text-align: center;
                    margin-top: 20px;
                }

                .cta-button {
                    display: inline-block;
                    padding: 15px 32px;
                    background-color: #C0A26B;
                    color: #20453d;
                    text-decoration: none;
                    border-radius: 25px;
                    font-weight: 600;
                    font-size: 1.1rem;
                    transition: all 0.3s ease;
                    box-shadow: 0 4px 16px rgba(192, 162, 107, 0.3);
                }

                .cta-button:hover {
                    background-color: #a67c52;
                    transform: translateY(-2px);
                    box-shadow: 0 6px 20px rgba(192, 162, 107, 0.4);
                }

                .fade-in {
                    opacity: 0;
                    transform: translateY(20px);
                    animation: fadeIn 1s ease-out forwards;
                }

                .preload .fade-in {
                    opacity: 0;
                    transform: translateY(20px);
                    animation: none;
                }

                @keyframes fadeIn {
                    from {
                        opacity: 0;
                        transform: translateY(20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                @media (max-width: 1200px) {
                    .details-grid {
                        grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
                    }
                }

                @media (max-width: 768px) {
                    .category-header {
                        height: 50vh;
                        background-attachment: scroll;
                    }

                    .category-header h1 {
                        font-size: 2.5rem;
                    }

                    .category-content {
                        padding: 32px 20px 60px;
                    }

                    .description-card {
                        padding: 24px;
                        margin-bottom: 32px;
                    }

                    .description-card p {
                        font-size: 1.1rem;
                    }

                    .category-details h2 {
                        font-size: 2.2rem;
                        margin-bottom: 24px;
                    }

                    .details-grid {
                        grid-template-columns: 1fr;
                        gap: 16px;
                    }

                    .detail-card {
                        padding: 20px;
                    }
                }
            `}</style>
        </div>
    );
}

export default FourruresPage;